export default function tasks(state = {}, action) {
  switch (action.type) {
    case 'GET_USER_TASKS':
      return {...state, userTasks: action.payload};
    default:
      return state;
  }
}
